import apiClient from '../http/apiClient';

export default class UserAPI {
    static user = () => apiClient.get('/user');
}
